import list_icon from '@/assets/img/device/mg68/list_icon_pro_max.png'
import { Mg68 } from './mg68'
import { KK } from '@/define/define'

export class Mg68Max extends Mg68 {
  name: string = 'MG68_MAX'
  icon: string = list_icon
  width: number = 710
  sleepTimeValues = [0, 30, 2 * 60, 3 * 60, 5 * 60, 15 * 60, 30 * 60, 1 * 60 * 60, 2 * 60 * 60, 4 * 60 * 60, 8 * 60 * 60, 12 * 60 * 60, 18 * 60 * 60]
  sleepTimeBTValues = this.sleepTimeValues
  fnFactoryKeys: KK[] = [0x1, 0x7, 0xd, 0x13, 0x19, 0x1f, 0x25, 0x2b, 0x31, 0x37, 0x3d, 0x43, 0x49, 0x4f, 0x8, 0xe, 0x14, 0x26, 0x44, 0x4a, 0x9, 0xf, 0xb, 0x59, 0x5e, 0x5f, 0x52, 0x4d, 0x53, 0x65, 0x29, 0x3b, 0x11]
}
